import { gql } from '@apollo/client';
import { GqlOrganization, GqlOrganizationFragment } from '../fragments/organization';

export interface Data {
  allOrganizations: Array<GqlOrganization>;
}

export const QUERY = gql`
  query AllOrganizations($searchTerm: String!) {
    allOrganizations(filter: { searchTerm: $searchTerm }) {
      ...OrganizationFields
      isTest
    }
  }
  ${GqlOrganizationFragment}
`;
